import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './index.css';

import $ from 'jquery';
import Highcharts from 'highcharts';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

$(document).ready(() => {
	Highcharts.setOptions({
		global: {
			useUTC: false
		}
	});
});



// WEBPACK FOOTER //
// ./src/index.js